import React, { useEffect } from 'react';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import { Grid } from '@material-ui/core';
import OperationHoursRangeCalendar from './OperationHoursRangeCalendar';
import TimeTable from './TimeTable';
import {
  clearForm,
  startRange,
  setSpecialEventRestaurantsPermissions,
} from './../../redux/actions/newOperationHoursActions';
import { getHolidays } from '../../redux/actions/holidays';
import {
  operationHoursPermission,
  otherSEPermission,
} from './constants/OperationHoursPermission';

function RangeDaySpecialEvent() {
  const dispatch: any = useDispatch();

  const { CountryId, RestaurantId, TimeZone } = useSelector(
    (state: RootStateOrAny) => state.RestaurantsReducer.entity,
  );

  useEffect(() => {
    return () => {
      dispatch(clearForm());
    };
  }, []);

  useEffect(() => {
    if (RestaurantId) {
      dispatch(startRange(RestaurantId));
    } else {
      dispatch(
        setSpecialEventRestaurantsPermissions({
          ...operationHoursPermission,
          ...otherSEPermission,
        }),
      );
    }
  }, [RestaurantId]);

  useEffect(() => {
    if (CountryId) {
      dispatch(getHolidays(CountryId));
    }
  }, [CountryId]);

  return (
    <React.Fragment>
      <Grid item xs={9} lg={3}>
        <OperationHoursRangeCalendar
          RestaurantId={RestaurantId}
          TimeZone={TimeZone}
        />
      </Grid>
      <TimeTable isRange={true} />
    </React.Fragment>
  );
}

export default RangeDaySpecialEvent;
